import { styled } from "@mui/material"
import { pixelToRemMap } from "@zuto/theme/src/mui/Typography"
import { dFlexCenter } from "@zuto/theme/src/mui/UtilityStyles"
import { space } from "@zuto/theme/src/mui/Core"

export type TypographyVariants = 
  'displayLarge'
  | 'displayMedium'
  | 'displaySmall'
  | 'headlineLarge'
  | 'headlineMedium'
  | 'headlineSmall'
  | 'titleLarge'
  | 'titleMedium'
  | 'titleSmall'
  | 'labelXLarge'
  | 'labelLarge'
  | 'labelMedium'
  | 'labelSmall'
  | 'bodyLarge'
  | 'bodyMedium'
  | 'bodySmall'
export type LabelVariants = Extract<TypographyVariants, 'labelXLarge' | 'labelLarge' | 'labelMedium' | 'labelSmall'>
export type BodyVariants = Extract<TypographyVariants, 'bodyLarge' | 'bodyMedium' | 'bodySmall'>

export type TextAlign = 'left' | 'center' | 'right'
export type TypographyColorOptions = '#333' | '#FFF'
export type TickIconColorOptions = 'lightGreen' | 'darkGreen'

export type BulletItem = {
  text: string
  icon?: string
}

export type HeadingDomElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
export type BodyDomElement = 'p'
export type UIDomElement = HeadingDomElement | BodyDomElement

export type ThemeOptions = 'light' | 'dark'
export type ButtonVariant = 'contained' | 'outlined' | 'text'

export type BackgroundImagePositionOptions = 
    'left top' | 'left center' | 'left bottom' |
    'right top' | 'right center' | 'right bottom' |
    'center top' | 'center center' | 'center bottom' |
    'top' | 'center' | 'bottom' | 'left' | 'right'

export interface CardType {
  title: string
  description: string
}

export type ComponentSpacingDesktop = "60px" | "40px" | "20px"
export type ComponentSpacingMobile = "40px" | "20px"
export interface BaseComponentProps {
  spacingBottomDesktop?: ComponentSpacingDesktop;
  spacingBottomMobile?: ComponentSpacingMobile;
}

export type ComponentLocation = 'body' | 'header'

export interface ButtonProps {
  content: string
  url?: string
  theme?: ThemeOptions
  variant?: ButtonVariant
  subText?: string
  subTextColour?: TypographyColorOptions
  openInNewTab?: boolean
  spacingBottomDesktop?: ComponentSpacingDesktop
  spacingBottomMobile?: ComponentSpacingMobile
  idSuffix: string,
  handleOnClick?: (event: React.MouseEvent<HTMLElement>) => void
}

export type CalculatorVariant = 'V1' | 'V2'

type CreditScore = 'Excellent' | 'Good' | 'Fair' | 'Poor' | 'Bad'
export interface CalculatorProps {
  id?: string,
  variant?: CalculatorVariant
  minHeight?: string
  title?: string,
  titleTag?: HeadingDomElement,
  creditScore?: CreditScore,
  showRepExample?: boolean,
  utmParams?: string
}


interface ElementContainerProps {
    dFlex?: boolean
}

export const ElementContainer = styled('div')<ElementContainerProps>(({ theme, dFlex }) => ({
    maxWidth: pixelToRemMap[1128],
    margin: '0 auto',
    padding: `0 ${space.spacing[7]}px`,
    ...(dFlex && {
        ...dFlexCenter
    }),
    [theme.breakpoints.up('sm')]: {
        paddingLeft: `${space.spacing[11]}px`,
        paddingRight: `${space.spacing[11]}px`
    },
    [theme.breakpoints.up('lg')]: {
        paddingLeft: `${space.spacing[8]}px`,
        paddingRight: `${space.spacing[8]}px`
    }
}))